<div class="container-fluid main-padding">
    <div class="container p-0 mp015">
        <app-matloader *ngIf="listingLoader"></app-matloader>
        <div class="row">
            <a href="javascript: void();" class="filter-res-menu"><i class="ti-filter"></i></a>
            <div class="col-md-3 col-12 filter">
                <div class="col-md-12 col-12 dp0 main-filter"> 
                    <div class="col-md-12 col-12 dp0 dpad0">
                            <h5>Filter</h5>
                        </div>
                    <form [formGroup]="searchForm" method="post" accept-charset="utf-8">
                        
                        <div class="col-md-12 col-12 dp0 filter1" style="display: none">
                            <h6>Property Type </h6>
                            <div class="col-md-12 col-12 dpad0 bhkfor">
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <input type="radio" id="radio1" value="2" class="noof_bhk" name="property_type"
                                            [formControl]="property_type">
                                        <label for="radio1">Buy</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="radio2" value="1" class="noof_bhk" name="property_type"
                                            [formControl]="property_type">
                                        <label for="radio2">Rent</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="radio3" value="3" class="noof_bhk" name="property_type"
                                            [formControl]="property_type">
                                        <label for="radio3">PG</label>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr>
                        <div class="col-md-12 col-12 dp0 filter1">
                            <h6>Location </h6>
                            <div class="col-12 dpad0 bhkfor">
                                <input id="form-tags-4" ngx-google-places-autocomplete formControlName="location"
                                    value="{{ homesearch.location }}" (keyup)="handleAddressChange($event,'mannual')"
                                    (onAddressChange)="handleAddressChange($event,'address')" [options]="options"
                                    placeholder='Type Location' class="filter-search-box input-box" />
                            </div>
                        </div>
                        <hr>

                        <div class="col-12 dp0 filter1">
                            <h6>Budget</h6>
                            <div class="col-md-12 col-12 dpad0 bhkfor">
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <select class="cs-select cs-skin-elastic" formControlName="min_budget">
                                            <option value="" disabled>Min</option>
                                            <option *ngFor="let minPrice of budgetMin" value="{{ minPrice }}">
                                                {{ getBudgetWords(minPrice) }}</option>
                                        </select>
                                    </li>
                                    <li class="list-inline-item"> - </li>
                                    <li class="list-inline-item">
                                        <select formControlName="max_budget">
                                            <option value="" disabled>Max</option>
                                            <option *ngFor="let maxPrice of getBudgetMaxValue()" value="{{ maxPrice }}">
                                                {{ getBudgetWords(maxPrice) }}</option>
                                        </select>
                                    </li>
                                </ul>
                            </div>
                        </div>
                         <hr>
                        <span *ngIf="(property_type.value=='2')">
                            <div class="col-md-12 col-12 dp0 filter1">
                                <h6>Type of Property</h6>
                                <div class="col-md-12 col-12 dpad0 bhkfor">
                                    <ul class="list-inline">
                                        <li class="list-inline-item" *ngIf="property_typee.value=='1'">
                                            <input type="checkbox" checked="checked" 
                                                id="residenial1" class="property_type" value="1"
                                                (click)="setPropertyTypeValue()">
                                            <label for="residenial1">Apartment/Flat/Builder Floor</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='1'">
                                            <input type="checkbox" checked="checked" 
                                                id="residenial2" class="property_type" value="2"
                                                (click)="setPropertyTypeValue()">
                                            <label for="residenial2">Independent House</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_type.value=='2' && property_typee.value=='1'">
                                            <input type="checkbox" checked="checked" 
                                                id="residenial33" class="property_type" value="4"
                                                (click)="setPropertyTypeValue()">
                                            <label for="residenial33">Residential Plot/Land</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='2'">
                                            <input type="checkbox" checked="checked" 
                                                id="commercial1" class="property_type" value="5"
                                                (click)="setPropertyTypeValue()">
                                            <label for="commercial1">Commercial Shops/Showroom</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='2'">
                                            <input type="checkbox" checked="checked" 
                                                id="commercial2" class="property_type" value="6"
                                                (click)="setPropertyTypeValue()">
                                            <label for="commercial2">Commercial Office/Space</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='2'">
                                            <input type="checkbox" checked="checked" 
                                                id="commercial3" class="property_type" value="7"
                                                (click)="setPropertyTypeValue()">
                                            <label for="commercial3">Commercial Plot/Land</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='3'">
                                            <input type="checkbox" checked="checked" 
                                                id="agriculture1" class="property_type" value="8"
                                                (click)="setPropertyTypeValue()">
                                            <label for="agriculture1">Agriculture Land</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='3'">
                                            <input type="checkbox" checked="checked" 
                                                id="agriculture2" class="property_type" value="9"
                                                (click)="setPropertyTypeValue()">
                                            <label for="agriculture2">Farmhouse</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='4'">
                                            <input type="checkbox" checked="checked" 
                                                id="agriculture3" class="property_type" value="10"
                                                (click)="setPropertyTypeValue()">
                                            <label for="agriculture3">Industry Plot/Land</label>
                                        </li>
                                        <li class="list-inline-item" *ngIf="property_typee.value=='4'">
                                            <input type="checkbox" checked="checked" 
                                                id="industry1" class="property_type" value="13"
                                                (click)="setPropertyTypeValue()">
                                            <label for="industry1">Factory</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <hr>
                        </span>
                        <span *ngIf="property_type.value=='3'">
                            <div class="col-md-12 col-12 dp0 filter1">
                                <h6>Available category</h6>
                                <div class="col-12 dpad0 bhkfor">
                                    <ul class="list-inline">
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="pg_professional" class="noof_bhk pg_available" value="1"
                                                (click)="setValueOfPgAvl()" [checked]="getPgAvlValue.includes('1')">
                                            <label for="pg_professional">For Professionals</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="pg_students" class="noof_bhk pg_available" value="2"
                                                (click)="setValueOfPgAvl()" [checked]="getPgAvlValue.includes('2')">
                                            <label for="pg_students">For Students</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="pg_professstudents" class="noof_bhk pg_available" value="3"
                                                (click)="setValueOfPgAvl()" [checked]="getPgAvlValue.includes('3')">
                                            <label for="pg_professstudents">For Professionals & Students</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <hr>
                        </span>
                        <span *ngIf="property_type.value=='3'">
                            <div class="col-md-12 col-12 dp0 filter1">
                                <h6>Available for</h6>
                                <div class="col-12 dpad0 bhkfor">
                                    <ul class="list-inline">
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="pg_boys" class="noof_bhk pg_for" value="1"
                                                (click)="setValueOFPg()" [checked]="getPgValue.includes('1')">
                                            <label for="pg_boys">Boys</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="pg_girls" class="noof_bhk pg_for" value="2"
                                                (click)="setValueOFPg()" [checked]="getPgValue.includes('2')">
                                            <label for="pg_girls">Girls</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="pg_unisex" class="noof_bhk pg_for" value="3"
                                                (click)="setValueOFPg()" [checked]="getPgValue.includes('3')">
                                            <label for="pg_unisex">Both</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <hr>
                        </span>
                         <span *ngIf="property_typee.value=='1' ">
                        <span *ngIf="property_type.value=='1' ||  property_type.value=='2'">
                            <div class="col-md-12 col-12 dp0 filter1">
                                <h6>No. of BHK</h6>
                                <div class="col-12 dpad0 bhkfor">
                                    <ul class="list-inline">
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="checkbox1" class="noof_bhk bhk_checked" value="1"
                                                (click)="setNoOfBhkValue()">
                                            <label for="checkbox1">1 BHK</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="checkbox2" class="noof_bhk bhk_checked" value="2"
                                                (click)="setNoOfBhkValue()">
                                            <label for="checkbox2">2 BHK</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="checkbox3" class="noof_bhk bhk_checked" value="3"
                                                (click)="setNoOfBhkValue()">
                                            <label for="checkbox3">3 BHK</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="checkbox4" class="noof_bhk bhk_checked" value="4"
                                                (click)="setNoOfBhkValue()">
                                            <label for="checkbox4">4 BHK</label>
                                        </li>
                                        <li class="list-inline-item">
                                            <input type="checkbox" id="checkbox5" class="noof_bhk bhk_checked" value="5"
                                                (click)="setNoOfBhkValue()">
                                            <label for="checkbox5">5 BHK & Above</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <hr>
                        </span>
                        </span>
                        <div class="col-12 dp0 filter1">
                            <h6>Sort By </h6>
                            <div class="col-md-12 col-12 dpad0 bhkfor">
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <input type="radio" id="relevance" class="noof_bhk" formControlName="sort_by"
                                            value="1">
                                        <label for="relevance">Relevance</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="l2h" class="noof_bhk" formControlName="sort_by"
                                            value="2">
                                        <label for="l2h">Low to High</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="h2l" class="noof_bhk" formControlName="sort_by"
                                            value="3">
                                        <label for="h2l">High to Low</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="o2n" class="noof_bhk" formControlName="sort_by"
                                            value="4">
                                        <label for="o2n">Old to New</label>
                                    </li>
                                    <li class="list-inline-item">
                                        <input type="radio" id="n2o" class="noof_bhk" formControlName="sort_by"
                                            value="5">
                                        <label for="n2o">New to Old</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-md-7 col-12 pd-0" *ngIf="properties.length>0">
                <div class="col-md-12 col-12 search-result-box p-0" style="display:none">
                    <h6>{{ properties.length }} Properties found</h6>
                </div>
                <div class="col-md-12 col-12 search-result-box p-0"  style="text-transform: capitalize;" *ngIf="getSearchText">
                    <h6>{{ getSearchText }}</h6>
                </div>
                <div class="row marginZero">
                    <div class="col-md-12 col-12 main-listing p-0" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                        [infiniteScrollThrottle]="throttle" (scrolled)="getAllPropertyWithScroll()">
                        <div class="row propria-prop-content" *ngFor="let property of properties;let i=index ">
                            <div class="col-md-4 col-12 pd-l0 mp0">
                                <a>
                                    <figure>
                                        <div id="demo{{i}}" class="carousel slide" data-ride="carousel"
                                            data-interval="2000">
                                            <div class="carousel-inner">
                                                <div class="carousel-item"
                                                    *ngFor="let image of property.images;let first=first;"
                                                    [ngClass]="{active: first}">
                                                    <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ image }}" class="img-fluid" alt="listing image">
                                                </div>
                                            </div>
                                            <a class="carousel-control-prev" href="#demo{{i}}" data-slide="prev"
                                                *ngIf="property.images.length>1">
                                                <i class="ti-angle-left"></i>
                                            </a>
                                            <a class="carousel-control-next" href="#demo{{i}}" data-slide="next"
                                                *ngIf="property.images.length>1">
                                                <i class="ti-angle-right"></i>
                                            </a>
                                        </div>
                                        <div class="image-overlay"></div>
                                        <span class="media-file">
                                            <i class="ti-video-camera" *ngIf="property.video"></i>
                                            <i class="ti-camera"></i> {{ property.images.length}}
                                        </span>
                                    </figure>
                                </a> 
                               <ul class="post-share">
                                    <li>Share On</li>
                                    <li class="wtsp"><a href="javascript: void(0);" (click)="sharePost('google',property.property_slug)"><i class="fa  fa-google"></i></a></li>
                                    <li class="fb-icon"><a href="javascript: void(0);"  (click)="sharePost('facebook',property.property_slug)"><i class="ti-facebook"></i></a></li>
                                    <li class="instagram-icon"><a href="javascript: void(0);" (click)="sharePost('instagram',property.property_slug)"><i class="ti-instagram"></i></a></li>
                                   
                                    <li class="wtsp"><a href="javascript: void(0);" (click)="sharePost('whatsup',property.property_slug)"><i class="fa fa-whatsapp"></i></a></li>
                                </ul>
                            </div>
                            <div class="col-md-8 col-12 pd-0">
                                <div class="propria-body">
                                    <div class="row marginZero">
                                        <div class="col-md-12 col-12 pd-0">
                                            <a target="_blank"  href="property-details/{{ property.property_type_name }}/{{ property.property_id }}">
                                                <h6 class="names-propria1">{{ property.property_title }}</h6>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="propria-body main-price">
                                        <div class="row">
                                            <div class="col-md-9 col-7">
                                                <a target="_blank"
                                                    href="/property-details/{{ property.property_type_name }}/{{ property.property_id }}">
                                                    <p *ngIf="(property.property_type=='2')">
                                                        <b>₹{{ property.priceinshort_words }}</b>&nbsp;&nbsp;
                                                        <small
                                                            *ngIf="(property.property_type=='1' || property.property_type=='2')">₹{{ property.priceper_unitvalue }}</small>
                                                    </p>

                                                    <p *ngIf="(property.property_type=='1' || property.property_type=='3')">
                                                        <b>₹{{ property.priceper_unitvalue }}</b>
                                                    </p>
                                                </a>  
                                            </div>
                                            <div class="col-md-3 col-5">
                                                <span class="whatsnear"><a href="javascript: void(0);"
                                                (click)="whatsNearByModalMap(property.location_lat,property.location_long,property.location)"><i
                                                    class="ti-location-pin"></i> What's near by</a></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="propria-body"> 
                                        <a target="_blank" href="/property-details/{{ property.property_type_name }}/{{ property.property_id }}">
                                        <ul class="flats-price">
                                            <li class="super-area" *ngIf="(property.property_type=='2' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='5'  || property.looking_subcat_type=='6'))">
                                                <span>Super Area</span>{{ property.super_area }}
                                            </li>
                                            <li class="property-area" *ngIf="(property.looking_subcat_type=='2' || property.looking_subcat_type=='4' || (property.property_type=='1' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='5' || property.looking_subcat_type=='6')) || property.looking_subcat_type=='7' || property.looking_subcat_type=='8' || property.looking_subcat_type=='9' || property.looking_subcat_type=='10' || property.looking_subcat_type=='13')">
                                                <span *ngIf="!(property.looking_subcat_type=='8' || property.looking_subcat_type=='9' || property.looking_subcat_type=='10' || property.looking_subcat_type=='13' )">Area</span>
                                                <span *ngIf="(property.looking_subcat_type=='8' || property.looking_subcat_type=='9' || property.looking_subcat_type=='10' || property.looking_subcat_type=='13' )">Land Area</span>
                                                {{ property.area }}
                                            </li>
                                            <li class="facing-road"
                                                *ngIf="((property.property_type=='1' && (property.looking_subcat_type=='2' || property.looking_subcat_type=='7' || property.looking_subcat_type=='9' || property.looking_subcat_type=='10' || property.looking_subcat_type=='13')) || (property.property_type=='2' && (property.looking_subcat_type=='4' || property.looking_subcat_type=='7' || property.looking_subcat_type=='8' || property.looking_subcat_type=='10' || property.looking_subcat_type=='13')))">
                                                <span>Width of Facing Road</span>{{ property.facing_road }} Foot
                                            </li>
                                            <li class="room"
                                                *ngIf="(property.property_type=='1' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2' || property.looking_subcat_type=='9')) || (property.property_type=='2' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2' || property.looking_subcat_type=='9'))">
                                                <span>Room</span>{{ property.room }}
                                            </li>
                                            <li class="facing"
                                                *ngIf="(property.property_type=='1' && (property.looking_subcat_type=='7' || property.looking_subcat_type=='13'))  || (property.property_type=='2' && (property.looking_subcat_type=='4' || property.looking_subcat_type=='7'))">
                                                <span>Facing</span>{{ property.facing }}
                                            </li>
                                            <li class="flooring"
                                                *ngIf="((property.property_type=='1' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='5' || property.looking_subcat_type=='6') || (property.property_type=='2' && (property.looking_subcat_type=='5' || property.looking_subcat_type=='6'))))">
                                                <span>Property on which floor</span>{{ property.property_which_floors }}
                                            </li>
                                            <li class="status" *ngIf="(property.property_type=='2' && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2' || property.looking_subcat_type=='5' || property.looking_subcat_type=='6' || property.looking_subcat_type=='9' || property.looking_subcat_type=='13')) || (property.property_type=='1' && property.looking_subcat_type=='6' || property.looking_subcat_type=='5' || property.looking_subcat_type=='13')">
                                                <span> Possession Status </span>{{ property.possession_status }}
                                            </li>
                                            <li class="furnishing"
                                                *ngIf="(property.property_type=='1' || property.property_type=='2') && (property.looking_subcat_type=='1' || property.looking_subcat_type=='2' || property.looking_subcat_type=='5' || property.looking_subcat_type=='6' || property.looking_subcat_type=='9')">
                                                <span>Furnishing</span>{{ property.furnished_type}}
                                            </li>
                                            <li class="ownership"
                                                *ngIf="(property.property_type=='2' && (property.looking_subcat_type=='4' || property.looking_subcat_type=='7'  || property.looking_subcat_type=='13'))">
                                                <span>Ownership</span>{{ property.ownership}}
                                            </li>
                                            <li class="water-supply"  *ngIf="(property.property_type=='2' && property.looking_subcat_type=='8') || (property.looking_subcat_type=='10')">
                                                <span>Water Supply</span>{{ property.watersupply_conn}}
                                            </li> 
                                            <li class="available" *ngIf="property.property_type=='3'">
                                                <span>Available For</span>{{ property.gender }}
                                            </li>
                                            <li class="room-type" *ngIf="property.property_type=='3'">
                                                <span>Room</span>{{ property.room_type }}
                                            </li>
                                            <li class="food" *ngIf="property.property_type=='3'">
                                                <span>Food</span>{{ property.food_option }}
                                            </li>
                                            <li class="pgcategory" *ngIf="property.property_type=='3'">
                                                <span>Available Category</span>{{ property.available_category }}
                                            </li> 
                                            <li class="power-backup" *ngIf="(property.property_type=='1' && (property.looking_subcat_type=='7') || (property.looking_subcat_type=='10')) || (property.property_type=='2' && (property.looking_subcat_type=='8'))">
                                                <span>Electricity Connection</span>{{ property.electrical_conn }}
                                            </li>
                                        </ul>
                                    </a>
                                    </div>
                                    <div class="by-build">
                                        <a target="_blank"  href="/property-details/{{ property.property_type_name }}/{{ property.property_id }}">
                                            <div class="property-agent">
                                                <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{ property.user_image }}" class="img-fluid" alt="agent">
                                                <ul>
                                                    <li><a href="#">{{ property.user_name }}</a></li>
                                                    <li><span>Posted on {{ property.posted_date }}</span></li>
                                                </ul>
                                            </div>
                                        </a>
                                        <div class="final-buttons" *ngIf="!property.propertyof_user">
                                            <a *ngIf="(property.property_type=='1' || property.property_type=='2')"
                                                href="javascript: void(0);"
                                                (click)="openLeadForm(property.property_type,property.property_id);leadForm.openLeadForm()"><i
                                                    class="ti-mobile"></i>
                                                Contact Now</a>

                                            <a *ngIf="(property.property_type=='3')" href="javascript: void(0);"
                                                (click)="openLeadForm('3',property.payingguest_id);leadForm.openLeadForm()"><i
                                                    class="ti-mobile"></i>
                                                Contact Now</a>
                                        </div>
                                        <div class="listing_actions" *ngIf="!property.propertyof_user"> 
                                            <a href="javascript: void(0);" title="Shortlist"
                                                (click)="addToWishlist(property.property_id,$event)">
                                                <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/wishlist-icon.png" class="img-fluid"
                                                    [ngClass]="{'shortlisted':chkPropertyWishlist.includes(property.property_id) }">
                                            </a>
                                        </div>
                                    </div>
                                    <!--<div class="by-build final-buttons">
                                        <div class="property-agent">
                                            <a href="javascript: void(0);" title="Share"><i class="ti-mobile"></i> Contact Now</a>
                                        </div>
                                        <div class="listing_actions">
                                            <a href="javascript: void(0);" title="Share"><i class="ti-heart"></i> Share Feedback</a>
                                        </div>
                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- sinner --> 
                <div class="row">
                    <div class="col-md-12 col-12 p-4 mp0">
                        <ngx-spinner bdOpacity=0.9 bdColor="" size="default" color="#db0c0c" type="ball-pulse-sync"
                            [fullScreen]="false">
                        </ngx-spinner>
                    </div>
                </div>
            </div>
             
            <div class="col-md-7 col-12 pd 0" *ngIf="properties.length==0">
                <div class="col-md-12 col-12 no-result-found usersformms">
                    <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/images/property-not-found.png" class="img-fluid" style="height:200px">
                    <p>No results matching your search!<br>
                        <small>Try removing some of the filters to get matching propertyresults</small>
                    </p>
                    <a href="javascript:void(0)" class="common-button" (click)="resetFilters()">Reset filters</a>
                </div>
            </div>

            <div class="col-md-2 col-12 pd-0 ad-sidebar" *ngIf="advBanner">
                <div class="col-md-12 col-12 listing-ad mp0">
                    <div class="card mb-2 col-md-12 col-6">
                        <a target="_blank" href="{{advBanner.url1}}"><img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{advBanner.image1}}" class="img-fluid" alt="ad image"></a>
                    </div> 
                    <div class="card mb-2 col-md-12 col-6">
                        <a target="_blank" href="{{advBanner.url2}}"><img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="{{advBanner.image2}}" class="img-fluid" alt="ad image"></a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!---Lead Form-->
<app-leadform [property_id]="leadpropetyId" #leadForm [leadTableName]="leadTableName"></app-leadform>

<div class="modal fade" id="mapModal">
    <div class="modal-dialog">
        <div class="modal-content" style="padding: 10px;background:#606062">
            <button type="button" class="close" data-dismiss="modal">
                <i class="ti-close"></i>
            </button>
            <div class="row marginZero"> 
                <div class="col-md-12 col-3 pd-0 nearby-items">
                    <div id="accordion">
                        <div class="card">
                            <div class="card-header">
                                <a class="card-link nearestgoogleplace" data-toggle="collapse" href="#collapseOne"
                                    (click)="nearByPlaceList('nearby','nearby')">
                                    <i class="ti-target"></i> Nearest
                                    <span class="symbol-input100 loading-icon nearby" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">Result not found with in 0.5 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#busStop"
                                    (click)="nearByPlaceList('bus_station','bus_station')">
                                    <i class="ti-direction"></i> Bus Stop
                                    <span class="symbol-input100 loading-icon bus_station" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="busStop" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Bus Stop found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#school"
                                    (click)="nearByPlaceList('school','school')">
                                    <i class="ti-pencil-alt"></i> School
                                    <span class="symbol-input100 loading-icon school" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="school" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No School found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#shoppingMall"
                                    (click)="nearByPlaceList('shopping_mall','shopping_mall')">
                                    <i class="ti-shopping-cart"></i> Shopping Mall
                                    <span class="symbol-input100 loading-icon shopping_mall" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="shoppingMall" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Shopping Mall found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#hospitals"
                                    (click)="nearByPlaceList('hospital','hospital')">
                                    <i class="ti-support"></i> Hospitals
                                    <span class="symbol-input100 loading-icon hospital" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="hospitals" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Hospitals found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#bankAtms"
                                    (click)="nearByPlaceList('bank,atm','bank')">
                                    <i class="ti-credit-card"></i> Banks/ATMs
                                    <span class="symbol-input100 loading-icon bank" style="display: none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="bankAtms" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Bank/ATM's with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#groceryStores"
                                    (click)="nearByPlaceList('grocery_or_supermarket','grocery')">
                                    <i class="ti-briefcase"></i> Grocery Stores
                                    <span class="symbol-input100 loading-icon grocery" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="groceryStores" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Grocery Stores found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#pharmacy"
                                    (click)="nearByPlaceList('pharmacy','pharmacy')">
                                    <i class="ti-clipboard"></i> Pharmacy
                                    <span class="symbol-input100 loading-icon pharmacy" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="pharmacy" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Pharmacy found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#restaurent"
                                    (click)="nearByPlaceList('restaurent','restaurent')">
                                    <i class="ti-home"></i> Restaurant
                                    <span class="symbol-input100 loading-icon restaurent" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="restaurent" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Restaurant found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#movies"
                                    (click)="nearByPlaceList('movie_theater','movie_theater')">
                                    <i class="ti-video-clapper"></i> Movies
                                    <span class="symbol-input100 loading-icon movie_theater" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="movies" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Movies found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#park"
                                    (click)="nearByPlaceList('park','park')">
                                    <i class="ti-shine"></i> Park
                                    <span class="symbol-input100 loading-icon park" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="park" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Park found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#gym"
                                    (click)="nearByPlaceList('gym','gym')">
                                    <i class="ti-wheelchair"></i> Gym
                                    <span class="symbol-input100 loading-icon gym" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="gym" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Gym found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <a class="collapsed card-link" data-toggle="collapse" href="#petrolPump"
                                    (click)="nearByPlaceList('petrol_station','petrol')">
                                    <i class="ti-paint-bucket"></i> Petrol Pump
                                    <span class="symbol-input100 loading-icon petrol" style="display:none">
                                        <div class="lds-dual-ring"></div>
                                    </span>
                                </a>
                            </div>
                            <div id="petrolPump" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <ul>
                                        <li *ngFor="let near of nearplaceList"><i class="ti-location-pin"></i>
                                            {{ near.name }}</li>
                                        <li *ngIf="nearplaceList.length==0">No Petrol Pump found with in 1 Km</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-12 pd-0" id="gmap_canvas">
                    <agm-map [latitude]="location_lat" [zoomControl]="false" [longitude]="location_long" [mapTypeControl]='true' [mapDraggable]="false" [zoom]="12"
                        (mapReady)="setmap($event)">
                        <agm-marker [latitude]="location_lat" [longitude]="location_long">
                            <agm-info-window>
                                <strong [innerHtml]="location"></strong>
                            </agm-info-window>
                        </agm-marker>

                        <agm-marker *ngFor="let m of nearplaceList" [latitude]="m.geometry.location.lat()"
                            [longitude]="m.geometry.location.lng()">
                            <agm-info-window>
                                <strong [innerHtml]="m.name"></strong>
                            </agm-info-window>
                        </agm-marker>
                    </agm-map>
                </div>
            </div>
            <button type="button" class="close" data-dismiss="modal"><i class="ti-close"></i></button>
        </div>
    </div>
</div>